import type {
  TPaycallActiveCallsResponse,
  TPaycallRecordingPreferenceResponse,
  TPaycallWebhookPayload,
  TSipCredentials,
} from "../paycall/paycall.types";
import { api } from "./api";

export const paycallApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPaycallSipCredentials: build.query<TSipCredentials, void>({
      query: () => ({
        url: `/Paycall/sip-credentials`,
        method: "GET",
      }),
    }),
    getPaycallActiveCalls: build.query<TPaycallActiveCallsResponse, void>({
      query: () => ({
        url: `/Paycall/active-calls`,
        method: "GET",
      }),
    }),
    postPaycallWebhook: build.mutation<
      { success?: boolean },
      TPaycallWebhookPayload
    >({
      query: (body) => ({
        url: `/Paycall/webhook`,
        method: "POST",
        body,
      }),
    }),
    setPaycallRecordingPreference: build.mutation<
      TPaycallRecordingPreferenceResponse,
      { uniqueId: string; saveRecording: boolean }
    >({
      query: ({ uniqueId, saveRecording }) => ({
        url: `/Paycall/calls/${encodeURIComponent(uniqueId)}/recording-preference`,
        method: "PUT",
        body: { saveRecording },
      }),
    }),
  }),
});

export const {
  useGetPaycallSipCredentialsQuery,
  useLazyGetPaycallSipCredentialsQuery,
  useLazyGetPaycallActiveCallsQuery,
  usePostPaycallWebhookMutation,
  useSetPaycallRecordingPreferenceMutation,
} = paycallApi;
